

































































import DatesFormat from '@/util/classes/datesFormat';
import { risk } from '@/util/transformString/translationsDecorator';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import {
  transactionsNotAffiliated
} from '@/store/interfaces/transactions';
import transaction from '@/store/types/transaction';
import PaymentMethods from '@/components/Reusable/paymentMethods.vue';
import StatusBadges from '@/components/Reusable/statusBadges.vue';
import DetailModal from '@/components/TransactionTickets/NoAffiliated/DetailModal.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'NotAffiliated',
  components: {
    DetailModal,
    StatusBadges,
    PaymentMethods,
  },
  data: () => ({
    viewDetails: false,
    propsToSearch: [] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'commerce_name',
        label: 'Comercio',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'user_name',
        label: 'Usuario',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'subtotal_formatted',
        label: 'Subtotal',
        minWidth: 150,
        sortable: true,
      },
      {
        prop: 'tip_formatted',
        label: 'Propina',
        minWidth: 100,
        sortable: true,
      },
      {
        prop: 'total_formatted',
        label: 'Total',
        minWidth: 100,
        sortable: true,
      },
      {
        prop: 'status',
        label: 'Estado',
        minWidth: 150,
        sortable: true,
        slotName: 'status',
      },
      {
        prop: 'card',
        label: 'Método de pago',
        minWidth: 150,
        slotName: 'card',
      },
      {
        prop: 'risk',
        label: 'Riesgo',
        minWidth: 100,
        sortable: true,
        formatter: (row: transactionsNotAffiliated): string => {
          return `${risk(String(row.risk))}`;
        },
      },
      {
        prop: 'created_at',
        label: 'Fecha y Hora',
        minWidth: 180,
        sortable: true,
        formatter: (row: transactionsNotAffiliated): string => {
          return `${formatDate.formatDateTime(row.created_at)}`;
        },
      }
    ] as tTableColumns,
    rowSelected: {
      id: '',
      status: 'pending',
      subtotal_cents: 0,
      subtotal_currency: '',
      subtotal_formatted: '',
      tip_cents: 0,
      tip_currency: '',
      tip_formatted: '',
      total_cents: 0,
      total_currency: '',
      total: {
        cents: 0,
        currency_iso: '',
      },
      total_formatted: '',
      authorization_number: null,
      created_at: '',
      updated_at: '',
      description: '',
      commerce_name: '',
      merchant_id: '',
      terminal_id: '',
      merchant_acquirer_code: '',
      transaction_type: '',
      bank_code: '',
      response_code: '',
      reference_number: '',
      risk: '',
      card_last_digits: '',
      network: '',
      user_name: '',
    } as transactionsNotAffiliated,
  }),
  computed: {
    ...mapGetters({
      getTransactionList: `transactionModule/${transaction.getters.GET_TRANSACTIONS_LIST_FOR_COMMERCE_NOT_AFFILIATED}`,
    }),
  },
  methods: {
    ...mapActions({
      transactionListForCommerceNotAffiliated:
        `transactionModule/${transaction.actions.TRANSACTIONS_LIST_FOR_COMMERCE_NOT_AFFILIATED}`,
    }),
    rowselect(row: transactionsNotAffiliated): void {
      this.rowSelected = row;
    },
    viewDetailsAction(): void {
      this.viewDetails = true;
    },
  },
});
